import { db, auth } from './config'; 
import { 
  doc, 
  setDoc, 
  addDoc, 
  collection, 
  serverTimestamp,
  deleteField 
} from 'firebase/firestore';
import { getNombreOperador } from './firebaseUtils';

/**
 * Mopotĩ pypuku kuatiakuéra rehegua Firestore-pe g̃uarã.
 * @param {Object|Array} data - Tembipuru oñemopotĩ va'erã.
 * @param {Boolean} isUpdate - Oĩramo ñemyatyrõ, oipuru deleteField().
 * @param {Boolean} isInsideArray - Array ryepýpe g̃uarã ñangareko.
 */
export const cleanPayload = (data, isUpdate = false, isInsideArray = false) => {
  // 1. Array-kuéra ñeñangareko (recursivo)
  if (Array.isArray(data)) {
    return data
      .map(v => (v && typeof v === 'object' && !(v instanceof Date)) ? cleanPayload(v, isUpdate, true) : v)
      .filter(v => {
        if (v === null || v === undefined || v === '') return false;
        if (typeof v === 'object' && !(v instanceof Date) && Object.keys(v).length === 0) return false;
        return true;
      });
  }

  // 2. Mba'ehechajua ñeñangareko
  return Object.entries(data).reduce((acc, [key, value]) => {
    
    // A. Meta-marandu mbohavara: 'id' ha 'path' araka'eve ndoñeñongatúi va'erã kuatia ryepýpe
    if (key === 'id' || key === 'path') {
      return acc; 
    }

    // B. Arange ñeñangarekoha ñemboyke (ojehecha ha oñemomba'apo upéicha)
    if (key === 'fechaCreacion' || key === 'ultimaModificacion') {
      if (value !== undefined) acc[key] = value;
      return acc;
    }

    // C. Firebase ñeñangareko techapyrã (FieldValue)
    if (value && typeof value === 'object' && (value._methodName || value.constructor?.name === 'FieldValue')) {
      acc[key] = value;
      return acc;
    }

    // D. Null ha Undefined ñeñangareko (Updates-pe g̃uarã)
    if (value === null || value === undefined) {
      if (isUpdate && !isInsideArray) {
        acc[key] = deleteField();
      }
      return acc;
    }

    // E. Ñe'ẽmbyatypy rupa
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed === '') {
        if (isUpdate && !isInsideArray) acc[key] = deleteField();
        return acc;
      }
      acc[key] = trimmed;
      return acc;
    }

    // F. Array rupa
    if (Array.isArray(value)) {
      const cleanedArray = cleanPayload(value, isUpdate, true);
      if (cleanedArray.length === 0) {
        if (isUpdate && !isInsideArray) acc[key] = deleteField();
      } else {
        acc[key] = cleanedArray;
      }
      return acc;
    }

    // G. Mba'ehechajua katuigua (Arange'ỹre)
    if (typeof value === 'object' && !(value instanceof Date)) {
      const cleanedObj = cleanPayload(value, isUpdate, isInsideArray);
      if (Object.keys(cleanedObj).length > 0) {
        acc[key] = cleanedObj;
      } else if (isUpdate && !isInsideArray) {
        acc[key] = deleteField();
      }
      return acc;
    }

    // H. Tembipuru ypykuéra (Booleans, Numbers)
    acc[key] = value;

    return acc;
  }, {});
};

/**
 * Ñeñongatuhára mbytegua opaite mba'épe g̃uarã.
 * @param {string} path - Mbyatypyre rape Firestore-pe.
 * @param {object} data - Tembipuru oñamongatútava.
 * @param {string|null} id - Kuatia rechaukaha oĩramo ñemyatyrõ.
 */
export const saveToFirestore = async (path, data, id = null) => {
  const isUpdate = !!id;
  
  // 1. Ñamopotĩ tembipuru Tembipytyñe'ẽ mbyatypýpe g̃uarã
  const dbSanitized = cleanPayload(data, isUpdate, false);
  
  // --- ◄ Mba'eapohára rechandy rupa (Wrapper de Auditoría Centralizada) ---
  // Ñamyatyrõ mba'eapohára rechandy marandukuéra ojehecha'ỹre
  let usuarioId = auth.currentUser?.uid || 'SISTEMA';
  let usuarioNombre = 'SISTEMA';
  try {
    // Ñaguahẽ mba'eapohára rérape techarãitépe
    const opNombre = getNombreOperador();
    if (opNombre) usuarioNombre = opNombre;
  } catch (e) {
    console.error("Mba'eapohára réra jejuhu javy:", e);
  }

  const auditData = {
    usuarioId,
    usuarioNombre,
    ultimaModificacion: serverTimestamp()
  };

  // Ñamongatu arange heñói hague oĩramo kuatia pyahu
  if (!isUpdate && !data.fechaCreacion) {
    auditData.fechaCreacion = serverTimestamp();
  }

  const dbPayload = {
    ...dbSanitized,
    ...auditData
  };

  // 2. Ñambosako'i mbohovái React (UI)-pe g̃uarã (ñamopyenda jey ID ha rape)
  const uiSanitized = cleanPayload(data, false, false); 
  const localResponse = {
    ...uiSanitized,
    usuarioId,
    usuarioNombre,
    ultimaModificacion: new Date(),
    id: id,
    path: data.path || null 
  };

  if (!isUpdate && !data.fechaCreacion) {
    localResponse.fechaCreacion = new Date();
  }

  try {
    if (id) {
      const docRef = doc(db, path, id);
      await setDoc(docRef, dbPayload, { merge: true });
      return localResponse;
    } else {
      const docRef = await addDoc(collection(db, path), dbPayload);
      localResponse.id = docRef.id;
      localResponse.path = `${path}/${docRef.id}`; 
      
      return localResponse;
    }
  } catch (error) {
    console.error("saveToFirestore ñamongatu javy:", error);
    throw error;
  }
};

/**
 * Ñamohenda tai rupive peteĩ array oñemoambue'ỹre upéva.
 * @param {Array} arr - Array oñemohendaséva.
 * @param {string|null} key - Mba'ehechajua mbyaty rehegua oĩramo.
 */
export const sortAlphabetically = (arr, key = null) => {
  if (!arr || !Array.isArray(arr)) return [];
  
  return [...arr].sort((a, b) => {
    // Ñaguahẽ tembipuru ñambojoja va'erã tai rupive
    const valA = key ? (a[key] || "") : a;
    const valB = key ? (b[key] || "") : b;

    // Ñapuru localeCompare castellano ñembohekópe tai ha papapykuérape g̃uarã
    return String(valA).localeCompare(String(valB), 'es', { 
      sensitivity: 'base',
      numeric: true 
    });
  });
};